import { Newspaper } from 'lucide-react';
import { NewsItemCard } from '../news/NewsItemCard';
import { feedKey } from '../news/feed';
import type { NewsFeedItem } from '../../types';
import { sectionError } from './useSectionQuery';
import type { SectionProps } from './useSectionQuery';
import { SectionShell } from './SectionShell';

export function LatestNewsSection(props: SectionProps<NewsFeedItem[]>) {
    const { data, loading, onRetry } = props;
    // The dashboard asks for five items; this block shows three.
    const items = (data ?? []).slice(0, 3);
    return (
        <SectionShell title="Latest news" icon={<Newspaper size={20} aria-hidden="true" />} linkTo="/news" linkLabel="Newsroom" loading={loading} error={sectionError(props)} onRetry={onRetry} skeletonRows={3}>
            {items.length === 0 ? (
                <div className="dash-quiet card">
                    <Newspaper size={20} aria-hidden="true" />
                    <span>Nothing published yet.</span>
                </div>
            ) : (
                <div className="news-items">
                    {items.map((item) => <NewsItemCard key={feedKey(item)} item={item} compact />)}
                </div>
            )}
        </SectionShell>
    );
}
